import type { FaireProductEntity } from "../../entity_types/product";

export const p_pb2q2a7qg5: FaireProductEntity = {
  token: "p_pb2q2a7qg5",
  type: "product",
  name: "4D Fruit Gummy Pineapple Burst 12 count",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/21fbe930dbc7a9d69f2665f816e62790915949d191ab1a0e15858dddef09c876.jpeg",
  priceDollars: 34.8,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e66ab442f76adc57179759c2b2ff0367a353247268d87d0fd13acf31f2843edd.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
